import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unlogged',
  templateUrl: './unlogged.component.html',
  styleUrls: ['./unlogged.component.scss'],
})
export class UnloggedComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
